// @noflow
import { DaySelectorItemDayNumber, DaySelectorItemWeekDay } from './styles';

import { momentObj } from 'react-moment-proptypes';
import PropTypes from 'prop-types';
import * as React from 'react';

const DaySelectorItem = ({ selected, day, onSelect }) => (
    <a onClick={onSelect}>
        <DaySelectorItemWeekDay>{day.format('dd')}</DaySelectorItemWeekDay>
        <DaySelectorItemDayNumber
            data-qa={selected ? 'day-selector-day-selected' : 'day-selector-day'}
            selected={selected}
        >
            {day.format('DD')}
        </DaySelectorItemDayNumber>
    </a>
);

DaySelectorItem.propTypes = {
    day: momentObj.isRequired,
    onSelect: PropTypes.func.isRequired,
    selected: PropTypes.bool
};

export default DaySelectorItem;



// WEBPACK FOOTER //
// ./src/components/widgets/day-selector/item.js